import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import CostObjectForm from "./CashFlowForm";
import CostObjectEdit from "./CashFlowEdit";
import CostObjectTable, {  MONTHLY_DUMMY } from "./table";

function CostObjectPage() {
  const [dataVersion, setDataVersion] = useState(0);
  const [copiedData, setCopiedData] = useState<any>(null);
  const [isEditMode, setEditMode] = useState<boolean>(false);
  const [editedData, setEditedData] = useState<any>(null);
  const [viewMode, setViewMode] = useState<"daily" | "monthly">("daily");
  const [groupByDueDate, setGroupByDueDate] = useState<boolean>(false);
  const [dailySummary, setDailySummary] = useState({ cashIn: 0, cashOut: 0, net: 0 });

  const [formFilters, setFormFilters] = useState<Record<string, string>>({
    book: "", strategy: "", trader: "", clearer: "",
    broker: "", product: "", counterparty: "", currency: "",
  });

const filteredDailyData: { cash_in: number | null; cash_out: number | null; net: number }[] = [];
  const filteredMonthlyData = MONTHLY_DUMMY; // monthly has no filters for now

  const totalCashIn = viewMode === "daily"
    ? filteredDailyData.reduce((sum, r) => sum + (r.cash_in ?? 0), 0)
    : filteredMonthlyData.reduce((sum, r) => sum + r.cash_in, 0);

  const totalCashOut = viewMode === "daily"
    ? filteredDailyData.reduce((sum, r) => sum + (r.cash_out ?? 0), 0)
    : filteredMonthlyData.reduce((sum, r) => sum + r.cash_out, 0);

  const totalNet = viewMode === "daily"
    ? filteredDailyData.reduce((sum, r) => sum + r.net, 0)
    : filteredMonthlyData.reduce((sum, r) => sum + r.net, 0);

  useEffect(() => {
    console.log("this the copied data ", copiedData);
  }, [copiedData]);

  useEffect(() => {
    console.log("dataVersion updated:", dataVersion);
  }, [dataVersion]);

  return (
    <>
      <div>
        <div className="page-body">
          {isEditMode ? (
            <Container fluid>
              <div className="table-ad">
                <CostObjectEdit
                  dataVersion={dataVersion}
                  setDataVersion={setDataVersion}
                  isEditMode={isEditMode}
                  editedData={editedData}
                  setEditMode={setEditMode}
                />
              </div>
            </Container>
          ) : (
            <Container fluid>
              <div className="table-ad">
                <CostObjectForm
                  dataVersion={dataVersion}
                  setDataVersion={setDataVersion}
                  copiedData={copiedData}
                  viewMode={viewMode}           
                  setViewMode={setViewMode}
                  groupByDueDate={groupByDueDate}
                  setGroupByDueDate={setGroupByDueDate}
                  formFilters={formFilters}           
                  setFormFilters={setFormFilters}     
                  totalCashIn={dailySummary.cashIn}           
                  totalCashOut={dailySummary.cashOut}         
                  totalNet={dailySummary.net}
                />
              </div>
            </Container>
          )}

          <CostObjectTable
            dataVersion={dataVersion}
            setDataVersion={setDataVersion}
            setCopiedData={setCopiedData}
            setEditMode={setEditMode}
            setEditedData={setEditedData}
            viewMode={viewMode}
            groupByDueDate={groupByDueDate}
            formFilters={formFilters}
            onDailySummaryChange={setDailySummary}
          />
        </div>
      </div>
    </>
  );
}

export default CostObjectPage;